import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { PAGE_SEO } from "constants/seo";
import PageSeo from "./PageSeo";
import {
  isPrivateAppRoute,
  isPublicProfileRoute,
} from "utils/seo";

const RouteSeo: React.FC = () => {
  const { pathname } = useLocation();

  const seo = useMemo(() => {
    if (isPublicProfileRoute(pathname)) {
      return null;
    }

    if (isPrivateAppRoute(pathname)) {
      return { noindex: true as const };
    }

    const normalized =
      pathname.length > 1 && pathname.endsWith("/")
        ? pathname.slice(0, -1)
        : pathname;

    const page = PAGE_SEO[normalized];
    if (page) {
      return {
        title: page.title,
        description: page.description,
        fullTitle: page.fullTitle,
        canonicalPath: normalized || "/",
        jsonLd: page.jsonLd,
        noindex: false as const,
      };
    }

    if (normalized === "/" || normalized === "") {
      const home = PAGE_SEO["/"];
      return {
        title: home.title,
        description: home.description,
        fullTitle: home.fullTitle,
        canonicalPath: "/",
        jsonLd: home.jsonLd,
        noindex: false as const,
      };
    }

    return { noindex: true as const };
  }, [pathname]);

  if (!seo) return null;

  if (seo.noindex) {
    return <PageSeo noindex canonicalPath={pathname} />;
  }

  return (
    <PageSeo
      title={seo.title}
      description={seo.description}
      fullTitle={seo.fullTitle}
      canonicalPath={seo.canonicalPath}
      jsonLd={seo.jsonLd}
    />
  );
};

export default RouteSeo;
